// frontend/src/components/Footer/Footer.jsx

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Box, Typography } from '@mui/material'; // Imported Typography
import ExtensionIcon from '@mui/icons-material/Extension';
import './Footer.css';

const Footer = ({ onOpenFaqModal, showFaqButton = true, hideNavLinks = false }) => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  
  // State to track if the user is using Google Chrome
  const [isChrome, setIsChrome] = useState(false);
  const [isEdge, setIsEdge] = useState(false);
  const [isExtensionInstalled, setIsExtensionInstalled] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent;
    // Edge identifies itself with "Edg"
    const isEdgeBrowser = /Edg/.test(userAgent);
    // Chrome must NOT contain "Edg" or "OPR"
    const isChromeBrowser = /Chrome/.test(userAgent) && !isEdgeBrowser && !/OPR/.test(userAgent);

    setIsEdge(isEdgeBrowser);
    setIsChrome(isChromeBrowser);

    // 2. CHECK IF EXTENSION IS INSTALLED
    // Check A: Has the content.js already modified the DOM?
    if (document.documentElement.getAttribute('data-vetra-extension') === 'installed') {
        setIsExtensionInstalled(true);
    }

    // Check B: Listen for the event in case React loaded faster than the extension
    const handleExtensionEvent = () => setIsExtensionInstalled(true);
    window.addEventListener('vetra-extension-installed', handleExtensionEvent);

    return () => {
        window.removeEventListener('vetra-extension-installed', handleExtensionEvent);
    };
  }, []);

  return (
    <footer className="footer">
      
      {/* 3. UPDATE THE CONDITION TO HIDE BUTTON IF INSTALLED */}
      {!isExtensionInstalled && (!hideNavLinks && (isChrome || isEdge)) && (
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
            <Button
                variant="outlined"
                href={isEdge 
                    ? "https://microsoftedge.microsoft.com/addons/detail/vetra-ai-analyzer/jmdgjbgckgniekbphiknlbnlicbcgbfh" 
                    : "https://chromewebstore.google.com/detail/vetra-ai-analyzer/mpldhheajpbgepkbifoeckppddjpmcil?pli=1"
                }
               target="_blank"
                rel="noopener noreferrer"
                startIcon={<ExtensionIcon />}
                sx={{
                    borderColor: 'rgba(255, 255, 255, 0.3)',
                    color: 'rgba(255, 255, 255, 0.8)',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    padding: '6px 16px',
                    borderRadius: '8px',
                    '&:hover': {
                        borderColor: 'white',
                        color: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    }
                }}
            >
                {isEdge ? t('footer.edgeExtension') : t('footer.chromeExtension')}
            </Button>
        </Box>
      )}

      {/* Social / Support Links */}
     <a href="mailto:support@vetra-ai.com" className="link-decoration" aria-label="Email Support">
        <i className="fa fa-envelope footer-symbol"></i>
      </a>
         
      {/* <a
        href="https://www.linkedin.com/in/diego-bettega-59a649b7/"
        className="link-decoration"
        aria-label="LinkedIn Profile"
      >
        <i className="fa-brands fa-linkedin footer-symbol"></i>
      </a>
         
      <a
        href="https://github.com/vetra-ai/vetra-ai/tree/main"
        className="link-decoration"
        aria-label="GitHub Repository"
      >
        <i className="fa-brands fa-github footer-symbol"></i>
      </a>
          */}
      
      {showFaqButton && (
        <>
          <button 
            onClick={onOpenFaqModal} 
            className="footer-faq-button" 
            // 3. Use the t() function for accessibility attributes
            aria-label={t('footer.faq.ariaLabel')}
            title={t('footer.faq.tooltip')}
          >
            <i className="fa fa-question-circle footer-symbol"></i> 
          </button>
        </>
      )}

      {!hideNavLinks && (
        <div className="footer-nav-links">
          {/* 4. Replace hardcoded link text with keys */}
          <Link to="/solutions" className="footer-link">{t('nav.solutions')}</Link>
          <Link to="/features" className="footer-link">{t('nav.features')}</Link>
          <Link to="/technology" className="footer-link">{t('nav.technology')}</Link>
          <Link to="/how-we-are-different" className="footer-link">{t('nav.howWeAreDifferent')}</Link>
          <Link to="/pricing" className="footer-link">{t('nav.pricing')}</Link>
          <Link to="/about" className="footer-link">{t('nav.about')}</Link>
          <Link to="/contact" className="footer-link">{t('nav.help')}</Link>
          <Link to="/privacy-policy" className="footer-link">{t('nav.privacy')}</Link>
          <Link to="/terms-of-service" className="footer-link">{t('nav.terms')}</Link>
        </div>
      )}

      <br />
      <br />
      <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.95)' }}>
        {t('footer.copyright', { year: year })}
      </Typography>
   </footer>
  );
}

export default Footer;